module.exports = new __parcel__URL__("little_lemon_tree_level_1.6495319c.png").toString();